import { render } from "./AdminSubscriptions.vue?vue&type=template&id=385abd04&scoped=true"
import script from "./AdminSubscriptions.vue?vue&type=script&lang=js"
export * from "./AdminSubscriptions.vue?vue&type=script&lang=js"

import "./AdminSubscriptions.vue?vue&type=style&index=0&id=385abd04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385abd04"]])

export default __exports__